import React from 'react';
import { Dialog, DialogProps } from '@mui/material';

interface DialogContainerProps extends Omit<DialogProps, 'children'> {
  children: React.ReactNode;
}

export const DialogContainer: React.FC<DialogContainerProps> = ({
  children,
  ...props
}) => {
  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: '#FFFFFF',
          borderRadius: '12px',
          overflow: 'hidden',
          maxHeight: '90vh',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
      {...props}
    >
      {children}
    </Dialog>
  );
};
